import {
  Alert,
  Avatar,
  Card,
  CardBody,
  DateTime,
  FunctionCard,
  Icon,
  Image,
  LineBreak,
  Link,
  OverviewCard,
  OverviewCardButton,
  Paragraph,
  Separator,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router"
import { IAppointmentData } from "./OfferAppointment"
import { generateIcs } from "./OfferAppointmentHelperComponents"
import OfferInfoComponent from "./OfferInfoPage"
import { OfferNavButtons } from "./OfferNavButtons"
import { ICON } from "@george-labs.com/george-assets/icons"

const IMAGE_URL = "./assets/succes.png"

const OfferSuccess = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const appointmentData: IAppointmentData = location?.state?.appointment
  const nextButtonText = t("common.button.ok")

  const addToCalendar = () => {
    const icsContent = generateIcs(
      t("offers.success.product"),
      t("offers.success.consultation"),
      appointmentData?.branch,
      appointmentData?.bookingStartTime,
      appointmentData?.duration,
    )
    const blob = new Blob([icsContent], { type: "text/calendar;charset=utf-8" })
    const url = URL.createObjectURL(blob)

    const a = document.createElement("a")
    a.href = url
    a.download = "mikro_folyoszamlahitel.ics"
    a.click()

    URL.revokeObjectURL(url)
  }

  const headerTitle = t("offers.success.title")

  const textContent = (
    <>
      <Paragraph
        style={{
          marginBottom: "2rem",
        }}
      >
        {t("offers.success.text")}
      </Paragraph>
      <Paragraph>{t("offers.success.text2")}</Paragraph>
    </>
  )

  const appointmentContent = (
    <OverviewCard
      avatar={<Avatar icon={Avatar.ICON.USER} />}
      subtitleLabel=""
      subtitle={t("offers.success.product")}
      title={t("offers.success.consultation")}
      defaultAction={<Link />}
      style={{
        lineHeight: "2.5rem",
        border: "1px",
        borderRadius: "16px",
      }}
      footer={
        <OverviewCardButton onClick={addToCalendar}>
          {t("offers.success.calendar")}
        </OverviewCardButton>
      }
    >
      {appointmentData?.bookingStartTime && (
        <>
          <Icon assetIcon={ICON.CLOCK} />{" "}
          <DateTime
            date={new Date(appointmentData.bookingStartTime)}
            format="yyyy.MM.dd. EEEE HH:mm"
          />
        </>
      )}
      {appointmentData?.bookingStartTime && appointmentData?.bookingEndTime && (
        <>
          {" "}
          -{" "}
          <DateTime
            date={new Date(appointmentData.bookingEndTime)}
            format="HH:mm"
          />
        </>
      )}
      {appointmentData?.bookingStartTime && <LineBreak />}
      {appointmentData?.branch && (
        <>
          <Icon assetIcon={ICON.LOCATION} /> {appointmentData.branch}
          <LineBreak />
        </>
      )}
      {appointmentData?.bookingCode && (
        <>
          <Icon assetIcon={ICON.PIN} /> {appointmentData.bookingCode}
        </>
      )}
    </OverviewCard>
  )

  const infoContent = (
    <Alert variant={Alert.VARIANT.INFO}>
      <Paragraph>{t("offers.success.info.text")}</Paragraph>
      <Paragraph>{t("offers.success.info.text2")}</Paragraph>
    </Alert>
  )

  const nextButtonHandler = () => {
    navigate(`/dashboard`, { replace: true })
  }

  const navButtonsContent = (
    <OfferNavButtons
      nextButtonText={nextButtonText}
      onNextButtonClicked={nextButtonHandler}
    />
  )

  const pageContent = useMatchMediaTierProp({
    xs: (
      <OfferInfoComponent
        buttonText={nextButtonText}
        headerText={headerTitle}
        imageUrl={IMAGE_URL}
        onButtonClicked={nextButtonHandler}
        textContent={textContent}
        otherContent={
          <>
            {appointmentContent}
            {infoContent}
          </>
        }
      />
    ),
    md: (
      <Card nested={false}>
        <FunctionCard
          padding={Card.PADDING.LARGE}
          heading={headerTitle}
          indicator={<Image src={IMAGE_URL} alt="" />}
        >
          <Paragraph>{t("offers.success.text")}</Paragraph>
        </FunctionCard>

        <Separator />

        <CardBody>
          <Paragraph
            style={{
              marginBottom: "2rem",
              textAlign: "center",
            }}
          >
            {t("offers.success.text2")}
          </Paragraph>

          {appointmentContent}

          {infoContent}
        </CardBody>

        <CardBody>{navButtonsContent}</CardBody>
      </Card>
    ),
  })

  return <>{pageContent}</>
}

export default OfferSuccess
